import { connect } from 'react-redux';
import InsertCertificate from './InsertCertificate';
import { getTranslation } from "../../../../reducers/common/localization";
import { fetchPutKey } from '../../../../reducers/accreditation/certificate';
import { resetSubmitFormData, fetchSubmitForm } from "../../../../reducers/common/submitForm";
import { isAccreditationSigningRequired } from '../../../../reducers/organization/organization';
import { getKey } from '../../../../reducers/accreditation/certificate';

const mapStateToProps = state => {
    return {
        signingKey: getKey(state),
        isSigningRequired: isAccreditationSigningRequired(state),
        translation: getTranslation(state)
    };
};


const mapDispatchToProps = dispatch => {
    return {
        onInsertKey: (jwk) => dispatch(fetchPutKey(jwk)),
        onSetLoading: () => {
            dispatch(fetchSubmitForm());
        },
        onStopLoading: () => {
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InsertCertificate);



// WEBPACK FOOTER //
// ./src/components/securityManagement/insertorSecurityComponent/insertCertificate/InsertCertificate.container.js